L.Modal = L.Class.extend({
	
	options:{
		
        vertivalCentered : false,
        animated : true,
        width : 'medium' ,
        backdrop : true,
		closeButton: true,
        escapeKeyboard : true ,
		className: ''
	},
	
	initialize: function(options, source){
		L.Util.setOptions(this, options);

		if (source){source.bindModal(this);}
		
//		jQuery.get({
//			url: pclm_ajax_object.ajaxurl,
//			method: 'GET',
//			data:{
//				"nonce": pclm_ajax_object.nonce_modal_parts,
//				"action":"modal_parts",
//				"id": "",
//				"part": 'default',
//				"destid": ""
//			},
//			context: this,
//			success: function(data){
//				this._default_modal_template = jQuery.parseHTML(data.html);
//			},
//			dataType: "json"
//
//		});
		

//		jQuery.get({
//			url: pclm_ajax_object.ajaxurl,
//			method: 'GET',
//			data:{
//				"action":"modal_parts",
//				"id": "",
//				"part": "default-container",
//				"destid": ""
//			},
//			context: this,
//			success: function(data){
//			
//				this._default_container = jQuery.parseHTML(data.html);
//				
//			},
//			dataType: "json"
//
//		});
		
//		jQuery.get({
//			url: pclm_ajax_object.ajaxurl,
//			method: 'GET',
//			data:{
//				"nonce": pclm_ajax_object.nonce_uploaded_parts,
//				"action":"uploaded_parts",
//				"id": "",
//				"part": "Modal/modal-loading",
//				"destid": ""
//			},
//			context: this,
//			success: function(data){
//			
//				this._loadingContent = jQuery.parseHTML(data.html);
//				
//			},
//			dataType: "json"
//
//		});
	},
	
	_setSource:function(source){
		this._source = source;
		this._source._modal = this;
	},
	
	setModalHtmlId: function(htmlId){
		this._htmlModalId = htmlId;
	},
	
	getModalHtmlId: function(){
		return this._htmlModalId;
	},

	setContent: function(content){
		this._content=content;
	},
	
	getContent: function(){
		return this._content;
	},
	
	_updateLayout: function () {
		var container = this._contentNode,
		    style = container.style;

		style.width = '';
		style.whiteSpace = 'nowrap';

		var width = container.offsetWidth;
		width = Math.min(width, this.options.maxWidth);
		width = Math.max(width, this.options.minWidth);

		style.width = (width + 1) + 'px';
		style.whiteSpace = '';

		style.height = '';

		var height = container.offsetHeight,
		    maxHeight = this.options.maxHeight,
		    scrolledClass = 'leaflet-popup-scrolled';

		if (maxHeight && height > maxHeight) {
			style.height = maxHeight + 'px';
			DomUtil.addClass(container, scrolledClass);
		} else {
			DomUtil.removeClass(container, scrolledClass);
		}

		this._containerWidth = this._container.offsetWidth;
	},
	
	
	display: function(){
		
	},
	
	toJSONable: function(){
		var jsonable= {};
		
		jsonable['type'] = "modal";
		jsonable['options'] = this.options;
		return jsonable;
	}
	
});


L.Map.addInitHook(function(){
	
	jQuery.get({
		url: pclm_ajax_object.ajaxurl,
		method: 'GET',
		data:{
			"nonce": pclm_ajax_object.nonce_modal_parts,
			"action":"modal_parts",
			"id": "",
			"part": 'default',
			"destid": ""
		},
		context: this,
		success: function(data){
			this._default_modal_template = jQuery.parseHTML(data.html);
		},
		dataType: "json"

	});

	jQuery.get({
		url: pclm_ajax_object.ajaxurl,
		method: 'GET',
		data:{
			"nonce": pclm_ajax_object.nonce_uploaded_parts,
			"action":"uploaded_parts",
			"id": "",
			"part": "Modal/modal-loading",
			"destid": ""
		},
		context: this,
		success: function(data){
		
			this._loadingContent = jQuery.parseHTML(data.html);
			
		},
		dataType: "json"

	});	
});


//@section Modal methods
L.Layer.include({

	// @method bindModal(content: String|HTMLElement|Function|Modal, options?: Modal options): this
	// Binds a modal to the layer with the passed `content` and sets up the
	// necessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindModal: function (modal, options) {

		if (modal instanceof L.Modal) {
			L.Util.setOptions(modal, options);
			modal._setSource(this);
		} else {
			if (!this._modal || options) {
				this._modal = new L.Modal(options, this);
			}
			this._modal.setContent(modal);
		}
		
		this.setModalRootNode();
		this.setModalEventManagers();		
		
		return this;
	},

	// @method unbindModal(): this
	// Removes the modal previously bound with `bindModal`.
	unbindModal: function () {
		if (this._modal) {
			this.unsetModalEventManagers();
			this.unsetModalRootNode();
			this._modal = null;
		}
		return this;
	},
	
	
	setModalEventManagers: function(){
		if (!this._modalHandlersAdded && !this._modalSuspended) {
			this.on({
				click: this._openModal,
				keypress: this._onKeyPress,
				remove: this.closeModal,
			});
			this._modalHandlersAdded = true;
		}
	},
	
	unsetModalEventManagers: function(){
		if (this._modalHandlersAdded) {		
			this.off({
				click: this._openModal,
				keypress: this._onKeyPress,
				remove: this.closeModal
			});
			this._modalHandlersAdded = false;	
		}
	},
	
	setModalRootNode: function(){
		if (this._modal && this.publication){
			this._modal.setModalHtmlId('#marker-info-'+ mapsManager.getMapHtmlId(this.publication.getParent()));
		}
	},
	
	unsetModalRootNode: function(){
		if (this._modal){
			this._modal.setModalHtmlId('');
		}
	},	
	
	suspendModalOpening: function(isSuspending){
		this._modalSuspended = isSuspending;
		if (this._modal){
			if (isSuspending){
				this.unsetModalEventManagers();
			}else{
				this.setModalEventManagers();
			}
		}
	},
	

	// @method openModal(latlng?: LatLng): this
	// Opens the bound modal at the specified `latlng` or at the default modal anchor if no `latlng` is passed.
	openModal: function (layer, latlng) {
		if (!(layer instanceof L.Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof L.FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (this._modal && this._modal._content && this._map) {
			jQuery(this._modal.getModalHtmlId()).modal('hide');
			if (jQuery(this._modal.getModalHtmlId()).hasClass('show')){
				jQuery(this._modal.getModalHtmlId()).on('hidden.bs.modal', function (e) {
					jQuery(this._modal.getModalHtmlId()).modal('dispose');
					jQuery(this._modal.getModalHtmlId()).replaceWith(this._modal._content);
					var e = jQuery.Event( "modalready" );
					 
					// trigger an artificial click event
					jQuery(this._modal.getModalHtmlId().replace("marker-info-","") ).trigger( e );
	
					
			        jQuery(this._modal.getModalHtmlId()).modal({backdrop:Boolean(this._modal.options.backdrop),keyboard:Boolean(this._modal.options.escapeKeyboard)});
					jQuery(this._modal.getModalHtmlId()).modal('show');				
				});	
			}else{
				var modal = this._modal;
				var modalDomId = this._modal.getModalHtmlId();
				var modalReloaded;
				var modalUpdatePromise = new Promise(function(resolve, reject){
					jQuery(modalDomId).modal('dispose');
					resolve(jQuery(modalDomId));
				}).then(function(response){
					 jQuery(modalDomId).replaceWith(modal._content);
					 return modal._content;
				}).then(function(response){
					jQuery(response).filter('.modal').attr('data-backdrop',Boolean(modal.options.backdrop));
					jQuery(response).filter('.modal').attr('data-keyboard',Boolean(modal.options.escapeKeyboard));	
					return response;
				}).then(function(response){
					var e = jQuery.Event( "modalready" );
					 
					// trigger an artificial click event
					jQuery(response).trigger( e );
					//jQuery(this._modal.getModalHtmlId().replace("marker-info-","") ).trigger( e );
					//jQuery(this._modal.getModalHtmlId()).modal({'backdrop':Boolean(this._modal.options.backdrop),'keyboard':Boolean(this._modal.options.escapeKeyboard)});

					jQuery(response).filter('.modal').modal('show');	
					return response;
				});			

			}


		}

		return this;
	},

	// @method closeModal(): this
	// Closes the modal bound to this layer if it is open.
	closeModal: function () {
		if (this._modal) {
			jQuery(this._modal.getModalHtmlId()).modal('hide');
			jQuery(this._modal.getModalHtmlId()).on('hidden.bs.modal', function (e) {
				jQuery(this._modal.getModalHtmlId()).empty();
			});
			
		}
		return this;
	},

	// @method toggleModal(): this
	// Opens or closes the modal bound to this layer depending on its current state.
	toggleModal: function (target) {
		if (this._modal) {
			if (this._modal._map) {
				this.closeModal();
			} else {
				this.openModal(target);
			}
		}
		return this;
	},

	// @method isModalOpen(): boolean
	// Returns `true` if the modal bound to this layer is currently open.
	isModalOpen: function () {
		return (this._modal ? this._modal.isOpen() : false);
	},

	// @method setModalContent(content: String|HTMLElement|Modal): this
	// Sets the content of the modal bound to this layer.
	setModalContent: function (content) {
		if (this._modal) {
			this._modal.setContent(content);
			var e = jQuery.Event( "modalupdate" );
			 
			// trigger an artificial click event
			jQuery(this._modal.getModalHtmlId()).trigger( e );			
		}
		return this;
	},

	// @method getModal(): Modal
	// Returns the modal bound to this layer.
	getModal: function () {
		return this._modal;
	},

	_openModal: function (e) {
		var layer = e.layer || e.target;

		if (!this._modal) {
			return;
		}

		if (!this._map) {
			return;
		}
		// prevent map click
		L.DomEvent.stop(e);
		this.openModal(layer, e.latlng);

	},


	_onKeyPress: function (e) {
		if (e.originalEvent.keyCode === 13) {
			this._openModal(e);
		}
	}
});